document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".tabbed-collections").forEach((section) => {

    const buttons = section.querySelectorAll(".tab-btn");
    const panels = section.querySelectorAll(".tab-panel");

    panels.forEach((panel) => {

      const swiper = panel.querySelector(".swiper");

      if (swiper) {

        new Swiper(swiper, {

          slidesPerView: 4,

          spaceBetween: 24,

          navigation: {
            nextEl: panel.querySelector(".swiper-button-next"),
            prevEl: panel.querySelector(".swiper-button-prev"),
          },

          breakpoints: {

            320: {
              slidesPerView: 2,
              spaceBetween: 16
            },

            768: {
              slidesPerView: 3
            },

            1200: {
              slidesPerView: 4
            }

          }

        });

      }

    });

    buttons.forEach((button) => {

      button.addEventListener("click", () => {

        buttons.forEach(btn => btn.classList.remove("active"));
        panels.forEach(panel => panel.classList.remove("active"));

        button.classList.add("active");

        const target = section.querySelector("#" + button.dataset.tab);

        target.classList.add("active");

      });

    });

  });

});